import { Tooltip } from 'antd';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';

import { cancelQuestionnaire } from '@/shared/api';
import { STATUS_CODE_OK } from '@/shared/constants/settings';
import { useShowTechnicalError } from '@/shared/hooks/use-show-technical-error';
import { useTranslate } from '@/shared/hooks/use-translate';
import { Button } from '@/shared/ui/button';
import { ExclamationIcon } from '@/shared/ui/icons';

import * as Styled from './styled';

type TProps = {
    number: string;
};

export const ActionCancel: FC<TProps> = ({ number }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslate();
    const { reload, locale } = useRouter();
    const { showError } = useShowTechnicalError();

    const tooltipText = t(
        'Если у вас изменились планы и вы не планируете забирать товар, то вы можете отменить бронирование',
    );

    const handleCancel = async () => {
        setIsLoading(true);

        const response = await cancelQuestionnaire(number, locale as string);

        if (response.statusCode === STATUS_CODE_OK) {
            reload();
        } else {
            showError(response.errorMessage);
        }

        setIsLoading(false);
    };

    return (
        <Styled.Wrapper>
            <p className="tooltip-text">{tooltipText}</p>
            <Button isLoading={isLoading} onClick={handleCancel}>
                {t('Отменить бронирование')}
            </Button>
            <Tooltip
                placement="bottom"
                title={<p style={{ color: '#1F2547', fontSize: '12px', lineHeight: '14px' }}>{tooltipText}</p>}
                color="white"
                overlayStyle={{ maxWidth: '230px' }}
            >
                <div>
                    <ExclamationIcon />
                </div>
            </Tooltip>
        </Styled.Wrapper>
    );
};
